import { Stack } from "@mui/material"
import { MetadataFormSectionCard } from "@features/builder/UpdateMetadata/MetadataFormSectionCard"
import { METADATA_FORM_SECTIONS } from "@features/builder/UpdateMetadata/helpers"
import { Controller } from "react-hook-form"
import { MarkdownEditor } from "@components/MarkdownEditor"

export const MetadataFormOverviewSection = () => {
  return (
    <MetadataFormSectionCard id={METADATA_FORM_SECTIONS.overview} title="Overview">
      <Stack direction="column" spacing={2}>
        <Controller
          name="overview"
          render={({ field, fieldState }) => (
            <MarkdownEditor {...field} errorMessage={fieldState?.error?.message} />
          )}
        />
      </Stack>
    </MetadataFormSectionCard>
  )
}

export default MetadataFormOverviewSection
